import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from "@angular/router";
import { MyAppoinmentsComponent } from "@app/features-modules/accountant/components/my-appoinments/my-appoinments.component";

@Injectable()
export class CanLogoutAccountantGuard implements CanDeactivate<MyAppoinmentsComponent> {
  canDeactivate(
    component: MyAppoinmentsComponent,
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot) {
    if ((nextState.url.indexOf('landing-page') > -1)) {
        return component.canLogout();
    } else {
        return true;
    }
  }
}
